import Cookies from 'js-cookie'
import { v4 as uuidv4 } from 'uuid'

const TokenKey = 'yale-web-token'
const LoginPhoneKey = 'yale-login-phone'
const PhoneKey = 'yale-phone'
const UUIDKey = 'yale-uuid'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getLoginPhone() {
  return Cookies.get(LoginPhoneKey)
}
// 参数名字不要与cookieKey名字一样，要不然会容易出现获取不了cookie值的情况
export function setLoginPhone(loginPhone) {
  setPhone(loginPhone)
  return Cookies.set(LoginPhoneKey, loginPhone)
}

export function setPhone(loginPhone) {
  return Cookies.set(PhoneKey, loginPhone)
}

export function getPhone() {
  return Cookies.get(PhoneKey)
}

export function removeLoginPhone() {
  return Cookies.remove(LoginPhoneKey)
}

export function getUUID() {
  const uuid = Cookies.get(UUIDKey)
  if (!uuid) {
    return setUUID()
  }
  return uuid
}

export function setUUID() {
  const uuid = uuidv4()
  Cookies.set(UUIDKey, uuid)
  return uuid
}

export function removeUUID() {
  return Cookies.remove(UUIDKey)
}



// WEBPACK FOOTER //
// ./src/common/auth.js